(function () {
  'use strict';
  function init(root) {
    if (root.dataset.wheelMediaReady) return;
    var track = root.querySelector('[data-wheel-media-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-wheel-media-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-wheel-media-thumb]'));
    var status = root.querySelector('[data-wheel-media-status]');
    if (!track || slides.length < 2 || slides.length !== thumbs.length) return;
    root.dataset.wheelMediaReady = 'true';
    var current = 0;
    var frame = 0;
    function update(index) {
      if (index === current) return;
      current = index;
      thumbs.forEach(function (thumb, at) {
        if (at === index) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      if (status) status.textContent = 'Image ' + (index + 1) + ' of ' + slides.length;
    }
    function closest() {
      var left = track.getBoundingClientRect().left;
      var best = 0;
      var distance = Infinity;
      slides.forEach(function (slide, index) {
        var delta = Math.abs(slide.getBoundingClientRect().left - left);
        if (delta < distance) { distance = delta; best = index; }
      });
      update(best);
    }
    function select(index) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      var delta = slides[index].getBoundingClientRect().left - track.getBoundingClientRect().left;
      track.scrollTo({ left: track.scrollLeft + delta, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      update(index);
    }
    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function (event) {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault(); select(index);
      });
    });
    track.addEventListener('keydown', function (event) {
      if (event.target !== track) return;
      var index;
      if (event.key === 'ArrowRight') index = current + 1;
      else if (event.key === 'ArrowLeft') index = current - 1;
      else if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = slides.length - 1;
      else return;
      event.preventDefault(); select(index);
    });
    track.addEventListener('scroll', function () {
      if (frame) return;
      frame = requestAnimationFrame(function () { frame = 0; closest(); });
    }, { passive: true });
  }
  function initAll(scope) {
    if (scope.matches && scope.matches('[data-wheel-media]')) init(scope);
    scope.querySelectorAll('[data-wheel-media]').forEach(init);
  }
  initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
